import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Breadcrumb
 * Props:
 *   items: [{ label: string, to?: string }]
 *   The last item is the current page (no link).
 */
const Breadcrumb = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="main-lwbl px-4 pt-6 pb-2"
    >
      <ol className="flex flex-wrap items-center gap-1 font-outfit text-sm text-gray-500">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-cyan-600 transition-colors">
            <Home size={14} />
            Home
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className="inline-flex items-center gap-1">
              <ChevronRight size={14} className="text-gray-300 flex-shrink-0" />
              {isLast || !item.to ? (
                <span className={isLast ? "font-semibold text-gray-800" : "text-gray-500"}>
                  {item.label}
                </span>
              ) : (
                <Link to={item.to} className="hover:text-cyan-600 transition-colors">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
